import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_input, {
      modelValue: _ctx.address,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address) = $event)),
      autofocus: "true",
      fill: "outline",
      shape: "round",
      onKeyup: _withKeys(_ctx.search, ["enter"]),
      placeholder: "Search by city & state or zip",
      disabled: _ctx.processingSearch,
      "data-cy": "input-search",
      class: "font-18",
      style: {"color":"black"},
      mode: "md"
    }, null, 8, ["modelValue", "onKeyup", "disabled"]),
    _createVNode(_component_ion_button, {
      onClick: _ctx.search,
      disabled: _ctx.processingSearch,
      clear: "",
      "item-right": "",
      fill: "clear",
      class: "ion-no-padding custom-button",
      "data-cy": "button-search"
    }, {
      default: _withCtx(() => [
        (_ctx.processingSearch)
          ? (_openBlock(), _createBlock(_component_ion_spinner, {
              key: 0,
              name: "lines-small"
            }))
          : (_openBlock(), _createBlock(_component_ion_icon, {
              key: 1,
              ios: _ctx.searchSharp,
              md: _ctx.searchSharp,
              color: "medium",
              slot: "end"
            }, null, 8, ["ios", "md"]))
      ]),
      _: 1
    }, 8, ["onClick", "disabled"]),
    false
      ? (_openBlock(), _createBlock(_component_ion_item, {
          key: 0,
          fill: "outline",
          mode: "md",
          class: "search-item"
        }))
      : _createCommentVNode("", true)
  ]))
}